export const mutations = {
  MutationSetUserFeedbackVideo(state, userFeedbackVideo) {
    state.userFeedbackVideo = userFeedbackVideo;
  },
  MutationSetUserFeedbackVideoLoadingStatus(state, status) {
    state.userFeedbackVideoLoadingStatus = status;
  },
};
